import { useTranslation } from 'react-i18next';

import { Card } from '../../components/Card';

export function SuccessState() {
  const { t } = useTranslation();
  return (
    <Card>
      <div className="state-icon success" aria-hidden="true">
        ✓
      </div>
      <h1>{t('success.title')}</h1>
      <p>{t('success.body')}</p>
    </Card>
  );
}
